import React, { useState } from 'react';

import styles from "./styles.module.css";
import { Accordion as BSAccordion, Card, useAccordionButton } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const CustomToggle = ({ children, eventKey, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useAccordionButton(eventKey, () => {
    setIsOpen(!isOpen);
    onToggle && onToggle(eventKey);
  });

  return (
    <button
      type="button"
      className={`${styles.itemBtn} d-flex justify-content-between align-items-center w-100`}
      onClick={handleClick}
    >
      {children}
      {isOpen ? (
        <FaChevronUp className={styles.chevron} />
      ) : (
        <FaChevronDown className={styles.chevron} />
      )}
    </button>
  );
};
const Accordion = (props) => {
  const handleToggle = (eventKey) => {
    props.onStateChange && props.onStateChange(eventKey);
  };

  return (
    <div style={{ borderStyle: 'solid', borderWidth: 0.2, borderRadius: 5, borderColor: props?.borderColor ? props?.borderColor : '#e0e0e0' }}>
      <BSAccordion defaultActiveKey={props.active ? "0" : null}>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: 'white', padding: 0, border: 'none' }}>
            <CustomToggle
              eventKey="0"
              onToggle={handleToggle}
            >
              {props.header}
            </CustomToggle>
          </Card.Header>
          <BSAccordion.Collapse eventKey="0">
            <Card.Body style={{ padding: 0 }}>
              {props.children}
            </Card.Body>
          </BSAccordion.Collapse>
        </Card>
      </BSAccordion>
    </div>
  );
};

export default Accordion;
